import { useState, useCallback, useEffect } from 'react';

export const useStoryNavigation = (storyId, storyData) => {
  const [currentScene, setCurrentScene] = useState(null);
  const [history, setHistory] = useState([]);
  const [currentChapter, setCurrentChapter] = useState('');

  useEffect(() => {
    setCurrentScene(null);
    setCurrentChapter('');
    setHistory([]);
  }, [storyData]);

  const loadScene = useCallback((chapterName, sceneId) => {
    console.log('Loading scene with data:', { storyData, chapterName, sceneId }); // Debug log
    if (!storyData) return;

    try {
      let chapter = storyData[chapterName];
      let targetChapter = chapterName;

      // If scene not found in current chapter, search other chapters
      if (!chapter || !chapter[sceneId]) {
        console.log('Scene not found in current chapter, searching others'); // Debug log
        for (const [chapName, chapData] of Object.entries(storyData)) {
          if (chapData[sceneId]) {
            chapter = chapData;
            targetChapter = chapName;
            break;
          }
        }
      }

      // If still not found, throw error
      if (!chapter || !chapter[sceneId]) {
        throw new Error(`Scene ${sceneId} not found in any chapter`);
      }

      const scene = chapter[sceneId];
      console.log('Found scene:', scene); // Debug log
      setHistory(prev => [...prev, { chapter: targetChapter, scene: sceneId }]);
      setCurrentScene({ ...scene, sceneId, chapterName: targetChapter });
      setCurrentChapter(targetChapter);
    } catch (error) {
      console.error('Error loading scene:', error);
    }
  }, [storyData]);

  const goBack = useCallback(() => {
    if (history.length > 1) {
      const newHistory = [...history];
      newHistory.pop();
      const previousScene = newHistory[newHistory.length - 1];
      setHistory(newHistory);
      loadScene(previousScene.chapter, previousScene.scene);
    }
  }, [history, loadScene]);

  return {
    currentScene,
    currentChapter,
    history,
    loadScene,
    goBack,
  };
}; 